<template>
  <div>
    <el-menu
      background-color="#333744"
      text-color="#fff"
      active-text-color="#409EFF"
      :default-active="this.$route.path"
      :unique-opened="true"
      :collapse-transition="false"
      router
    >
    <!-- <el-menu-item index="/home">
        <i class="el-icon-s-home"></i>
        <span slot="title">首页</span>
      </el-menu-item> -->
      <sub-menu v-for="item in menus" :key="item.path" :menuItem='item'></sub-menu>
      <!-- <el-menu-item index="/home">
        <i class="el-icon-s-home"></i>
        <span slot="title">首页</span>
      </el-menu-item>
      <el-submenu :index="item.path + ''" v-for="item in menus" :key="item.id">
        <template slot="title">
          <i :class="item.meta.icon"></i>
          <span>{{ item.meta.title }}</span>
        </template>
        <el-menu-item
          :index="subItem.path"
          v-for="subItem in item.children"
          :key="subItem.path"
        >
          <template slot="title">
            <i :class="subItem.meta.icon"></i>
            <span>{{ subItem.meta.title }}</span>
          </template>
        </el-menu-item>
      </el-submenu> -->
    </el-menu>
  </div>
</template>

<script>
import router from "@/router"
import subMenu from './subMenu'
export default {
  data() {
    return {
      menus: [],
    };
  },
  components:{
    subMenu
  },
  mounted() {
    let menus = router.options.routes;
    let arr = menus.filter((item) => !item.isHide);
    arr.forEach((item) => {
      if (item.children) {
        let subArr = item.children.filter((subItem) => !subItem.isHide);
        item.children = subArr;
      }
    });
    this.menus = arr;
  },
  methods: {
  
  },
};
</script>

<style scoped>
.el-menu {
  height: 100%;
  border-right: none;
}
.el-submenu__title,.el-menu-item{
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/LeftMenu.vue